/* eslint-disable react-refresh/only-export-components */
export const TABLE_CHIP_BASE =
  'inline-flex items-center justify-center w-auto h-[36px] laptop:!h-8 gap-[10px] px-4 laptop:!px-3 text-sm rounded-lg whitespace-nowrap capitalize opacity-100';

export const TABLE_CHIP_TONES = {
  success: 'text-[#50AB3D] bg-[#EBF4EA]',
  error: 'text-[#FF383C] bg-[#FCEAEC]',
  warning: 'text-amber-600 bg-amber-500/10',
  info: 'text-blue-500 bg-blue-500/10',
  primary: 'text-purple-500 bg-purple-500/10',
  neutral: 'text-[#868686] bg-[#F5F5F5]',
};

/**
 * Shared table chip — same shape/spacing as dashboard lead stage badges.
 */
export function TableChip({
  children,
  tone = 'neutral',
  className = '',
  ...props
}) {
  return (
    <span
      className={`${TABLE_CHIP_BASE} ${TABLE_CHIP_TONES[tone] || TABLE_CHIP_TONES.neutral} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
}

/** Map consent_status API/UI values to TableChip tone. */
export function getConsentChipTone(status) {
  const slug = String(status || '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '_');
  if (slug === 'opt_in' || slug === 'optin') return 'success';
  if (slug === 'opt_out' || slug === 'optout') return 'error';
  return 'neutral';
}

/** Map pipeline/lead stage name to TableChip tone. */
export function getStageChipTone(stageName) {
  const slug = String(stageName || '').toLowerCase();
  if (slug.includes('new')) return 'info';
  if (slug.includes('contact')) return 'warning';
  if (slug.includes('won')) return 'success';
  if (slug.includes('lost')) return 'error';
  return 'primary';
}
